import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { migrateMaintenanceDataToSupabase } from '@/services/maintenanceService';
import { toast } from 'sonner';
import { Loader2 } from 'lucide-react';

interface DataMigrationButtonProps {
  onMigrationComplete?: () => void;
}

const DataMigrationButton: React.FC<DataMigrationButtonProps> = ({ onMigrationComplete }) => {
  const [isMigrating, setIsMigrating] = useState(false);

  const handleMigration = async () => {
    setIsMigrating(true);
    try {
      const success = await migrateMaintenanceDataToSupabase();
      
      if (success) {
        toast.success('Datos migrados correctamente a la base de datos');
        if (onMigrationComplete) {
          onMigrationComplete();
        }
      } else {
        toast.error('Error al migrar los datos');
      }
    } catch (error) {
      console.error('Error durante la migración:', error);
      toast.error('Error al migrar los datos');
    } finally {
      setIsMigrating(false);
    }
  };

  return (
    <Button 
      variant="outline" 
      onClick={handleMigration} 
      disabled={isMigrating}
      className="w-full"
    >
      {isMigrating ? (
        <>
          <Loader2 className="mr-2 h-4 w-4 animate-spin" />
          Migrando datos...
        </>
      ) : (
        <>Migrar datos de localStorage a la base de datos</>
      )}
    </Button>
  );
};

export default DataMigrationButton; 